import { render, staticRenderFns } from "./risk-analysis.vue?vue&type=template&id=1a22b89a&"
import script from "./risk-analysis.vue?vue&type=script&lang=js&"
export * from "./risk-analysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports